import { forwardRef, type Ref, type SVGProps } from "react";
const IconMonitorFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M2 21a2 2 0 0 0 2 2h9v3h-3a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2h-3v-3h9a2 2 0 0 0 1.1-.3 2.3 2.3 0 0 0 .6-.6A2 2 0 0 0 30 21v-2H2zM29.7 4.9a2.3 2.3 0 0 0-.6-.6A2 2 0 0 0 28 4H4a2 2 0 0 0-2 2v11h28V6a2 2 0 0 0-.3-1.1" /></svg>;
const ForwardRef = forwardRef(IconMonitorFilledSVG);
ForwardRef.displayName = "IconMonitorFilled";
export { ForwardRef as IconMonitorFilled };